import { uploadFiles } from "api/postApi";
import {
  CONFIG_OPTION_TOAST_ERROR,
  CONFIG_OPTION_TOAST_NORMAL,
} from "common/toast";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import IconDeltete from "../../assets/images/icon-delete.png";
import IconDoc from "../../assets/images/type/doc.png";
import IconGif from "../../assets/images/type/gif.png";
import IconPdf from "../../assets/images/type/pdf.png";
import IconNotSupport from "../../assets/images/type/not_support.png";
import IconXls from "../../assets/images/type/xls.png";
import IconZip from "../../assets/images/type/zip.png";
import IconPowerPoint from "../../assets/images/type/power_point.png";

const renderFileName = (fileName: string) => {
  const fileNameWithoutExtension =
    fileName?.length > 30
      ? fileName.slice(0, 15) + "..." + fileName.slice(-12)
      : fileName;
  return (
    <div>
      <span>{fileNameWithoutExtension}</span>
    </div>
  );
};

const renderImgType = (values: string) => {
  const str = values?.split(".");
  const type = str?.[str?.length - 1];
  console.log("type", type);

  switch (type) {
    case "jpg":
    case "jpeg":
    case "png":
    case "svg":
    case "bmp":
    case "webp":
    case "tiff":
    case "tif":
      return values;

    case "txt":
    case "rtf":
    case "doc":
    case "docx":
      return IconDoc;
    case "xls":
    case "xlsx":
    case "csv":
      return IconXls;

    case "ppt":
    case "pptx":
      return IconPowerPoint;

    case "pdf":
      return IconPdf;

    case "gif":
      return IconGif;

    case "zip":
    case "rar":
    case "7z":
    case "tar":
    case "gz":
    case "bz2":
      return IconZip;

    default:
      return IconNotSupport;
  }
};

const UploadSource = ({ onLoad, data, name }: any) => {
  const { t } = useTranslation();
  const [file, setFile] = useState<any>([]);
  const handleFileChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const input = document.getElementById(name) as HTMLInputElement;
    try {
      const files = event.target.files;
      if (files && files.length > 0) {
        const fileArray = Array.from(files);
        const formData = new FormData();
        fileArray.forEach((file) => {
          formData.append("files", file);
        });

        const res = (await uploadFiles(formData)) as any;
        if (res?.statusCode === 200) {
          setFile(res?.data);
          onLoad(res?.data);
          toast(
            `${t("The process has been completed.")}`,
            CONFIG_OPTION_TOAST_NORMAL
          );
        } else {
          toast(`${res}`, CONFIG_OPTION_TOAST_ERROR);
        }
      }
    } catch (error) {
      toast(`${error}`, CONFIG_OPTION_TOAST_ERROR);

      console.error("Error handling file change:", error);
    } finally {
      input.value = "";
    }
  };

  useEffect(() => {
    if (data?.length > 0) {
      setFile(data);
    }
  }, [data]);
  return (
    <div>
      {!!file?.length ? (
        <div>
          {file?.map((item: any, index: number) => (
            <div
              key={index}
              className="position-relative d-flex gap-3"
              style={{ width: "100px" }}
            >
              <img
                src={
                  item?.fullPath ||
                  renderImgType(item?.fullPath || item) ||
                  item
                }
                alt="Uploaded"
                style={{ width: "100px", height: "100px" }}
              />
              <a
                href={item?.fileName || item}
                target="_blank"
                className="m-0 text-nowrap"
              >
                {renderFileName(item?.fileName || item)}
              </a>
              <div
                className="position-absolute cursor-pointer"
                style={{ top: "-10px", right: "-5px", color: "red" }}
                onClick={() => {
                  const updatedFiles = file.filter(
                    (fileItem: any) => fileItem?.fileName !== item?.fileName
                  );
                  setFile(updatedFiles);
                  onLoad(updatedFiles, index);
                }}
              >
                <img src={IconDeltete} alt="delete" width={18} height={18} />
              </div>
            </div>
          ))}
        </div>
      ) : (
        <label
          htmlFor={name}
          className="btn btn-primary d-flex align-items-center gap-2"
          style={{ cursor: "pointer", width: "fit-content" }}
        >
          <i className="ri ri-upload-cloud-2-line"></i>
          <p className="m-0">Upload File</p>
        </label>
      )}
      <input
        name={name}
        id={name}
        type="file"
        className="d-none"
        onChange={handleFileChange}
      />
    </div>
  );
};

export default UploadSource;
